import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { ProductStatusType, StepStatusType } from '../../../../../../models/order/order.model';
import { VideoFlow } from '../../../../../../models/order/workflow/video/video-flow.model';


@Injectable({ providedIn: 'root' })
export class VideoFlowStateService extends BaseWorkflowStateService<VideoFlow> {
    override stateKey: string = 'videoFlow';

    updateStatus(value: ProductStatusType) {
        this.updateData({ status: this.mapProductStatusToFlowStatus(value) });
    }

    override async markStepComplete() {
        this.updateData({ status: StepStatusType.Completed });
    }

    private mapProductStatusToFlowStatus(status: ProductStatusType): StepStatusType {
        switch (status) {
            case ProductStatusType.COMPLETED:
                return StepStatusType.Completed;
            case ProductStatusType.STARTED_BUT_NOT_FINISHED:
                return StepStatusType.InProgress;
            case ProductStatusType.REQUIRES_ATTENTION:
                return StepStatusType.RequiresAttention;
            case ProductStatusType.NOT_AVAILABLE:
                return StepStatusType.NotAvailable;
            case ProductStatusType.AVAILABLE_NOT_STARTED:
                return StepStatusType.AvailableNotStarted;
            default:
                return StepStatusType.InProgress;
        }
    }
}